<template>
  <Modal
    v-model="_value"
    width="900"
    title="添加安装订单"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Tabs type="card">
      <TabPane label="必要订单信息">
        <Form :model="installOrder" :rules="rules" :label-width="90">
          <Row>
            <Col span="8">
              <FormItem prop="registrationNum" label="车牌号码">
                <Input class="field" search v-model="installOrder.tempVehicleInfo.registrationNum" placeholder="请输入车牌号码">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="color" label="车牌颜色">
                <Select class="field" v-model="installOrder.tempVehicleInfo.registrationColor">
                  <Option v-for="item in registrationColorOptions" :value="item.value" :key="item.value">
                    {{item.label}}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vin" label="车架号">
                <Input class="field" v-model="installOrder.tempVehicleInfo.vin" placeholder="请输入车架号">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="totalAmount" label="应收总金额">
                <InputNumber :min="0" class="field" v-model="installOrder.totalAmount" placeholder="请输入应收总金额"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="serviceDateNum" label="服务期时长(月)">
<!--                <Select class="field" v-model="installOrder.businessType">-->
<!--                  <Option v-for="item in installOrderBusinessType" :value="item.value" :key="item.value">{{item.label}}</Option>-->
<!--                </Select>-->
                <InputNumber :min="0" class="field" v-model="serviceDateNum" controls-outside @on-change="changeServiceDateNum"></InputNumber>

              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="serviceDatetime" label="服务到期时间">
                <DatePicker class="field" type="date" v-model="installOrder.serviceDatetime"
                            placeholder="选择日期" @on-change="changeServiceDatetime"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="businessType" label="业务类型">
                <Select class="field" v-model="installOrder.businessType">
                  <Option v-for="item in installOrderBusinessType" :value="item.value" :key="item.value">{{item.label}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="engineNum" label="发动机号">
                <Input class="field" v-model="installOrder.tempVehicleInfo.engineNum" placeholder="请输入发动机号">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleTypeName" label="车辆类型">
                <Select
                  placeholder="请输入车辆类型名称"
                  v-model="installOrder.tempVehicleInfo.vehicleType.name"
                  filterable
                  remote
                  :remote-method="searchVehicleType"
                  :loading="searchVehicleTypeLoading"
                  class="field"
                  clearable>
                  <Option v-for="(option, index) in searchVehicleTypeList" :value="option.name" :key="option.name">{{option.name}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="businessUserId" label="跟进业务员">
                <Select class="field" v-model="installOrder.businessUserId">
                  <Option v-for="item in businessUsers" :value="item.id" :key="item.realName != null?item.realName:item.nickName != null?item.nickName:item.name">{{item.realName===null?item.name==null?item.nickName:item.name:item.realName}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="qghyptOption" label="全国货运平台">
                <Select class="field" v-model="installOrder.qghyptOption">
                  <Option v-for="item in qghyptOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="billType" label="开票类型">
                <Select class="field" v-model="installOrder.billType">
                  <Option v-for="item in billType" :value="item.value" :key="item.value">{{item.label}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="isfree" label="订单类型">
                <Select class="field" v-model="installOrder.isfree">
                  <Option v-for="item in orderTypeOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col v-if="installOrder.isfree != 1" span="8">
              <FormItem prop="mliftainsuranceChannelId" label="交强险公司">
                <Select
                  placeholder="请选择交强险公司"
                  v-model="installOrder.tempVehicleInfo.mliftainsuranceChannelId"
                  filterable
                  remote
                  :remote-method="searchMLIFTAinsuranceChannel"
                  :loading="searchMLIFTAinsuranceChannelLoading"
                  class="field" style="width: 70%;"
                  clearable>
                  <Option v-for="(option, index) in searchMLIFTAinsuranceChannelList" :value="option.id" :key="option.id">{{option.name}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col v-if="installOrder.isfree != 1" span="8">
              <FormItem prop="tiinsuranceChannelId" label="商业险公司">
                <Select
                  placeholder="请选择商业险公司"
                  v-model="installOrder.tempVehicleInfo.tiinsuranceChannelId"
                  filterable
                  remote
                  :remote-method="searchTIinsuranceChannel"
                  :loading="searchTIinsuranceChannelLoading"
                  class="field" style="width: 70%;"
                  clearable>
                  <Option v-for="(option, index) in searchTIinsuranceChannelList" :value="option.id" :key="option.id">{{option.name}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col v-if="installOrder.isfree != 1" span="8">
              <FormItem prop="insured" label="车主/受保人">
                <Input class="field" v-model="installOrder.tempVehicleInfo.insured" placeholder="请输入车主/受保人"></Input>
              </FormItem>
            </Col>
            <Col v-if="installOrder.isfree != 1" span="8">
              <FormItem prop="mliftainsurancechannelDatetime" label="交强险到期日">
                <DatePicker type="date" v-model="installOrder.tempVehicleInfo.mliftainsurancechannelDatetime"
                            placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
            <Col v-if="installOrder.isfree != 1" span="8">
              <FormItem prop="tiinsurancechannelDatetime" label="商业险到期日">
                <DatePicker type="date" v-model="installOrder.tempVehicleInfo.tiinsurancechannelDatetime"
                            placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="receptDatetime" label="是否已收款">
                <RadioGroup v-model="installOrder.receptDatetime">
                  <Radio label="是"></Radio>
                  <Radio label="否"></Radio>
                </RadioGroup>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="urgent" label="是否加急">
                <Space direction="vertical" size="large">
                  <RadioGroup v-model="installOrder.urgent">
                    <Radio label="是"></Radio>
                    <Radio label="否"></Radio>
                  </RadioGroup>
                </Space>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="bookingDatetime" label="预约安装时间">
                <DatePicker type="datetime" v-model="installOrder.bookingDatetime"
                            :options="options" @on-change="onChange	" placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
            <Col span="16">
              <FormItem prop="bookingPlace" label="预约安装地点">
                <Input class="field" v-model="installOrder.bookingPlace">
                </Input>
              </FormItem>
            </Col>
          </Row>
<!--          <Row>-->
<!--            <Col span="8">-->
<!--              <FormItem prop="multiDevices">-->
<!--                <Checkbox v-model="installOrder.multiDevices">多设备</Checkbox>-->
<!--              </FormItem>-->
<!--            </Col>-->
<!--          </Row>-->
          <Row>
            <Col span="12">
              <FormItem prop="clientInfoId" label="客户信息">
                <Select
                  placeholder="请选择客户名称"
                  v-model="installOrder.clientInfoId"
                  filterable
                  remote
                  :remote-method="searchClientInfo"
                  :loading="searchClientInfoLoading"
                  class="field" style="width: 60%;"
                  clearable>
                  <Option v-for="(option, index) in searchClientInfoList" :value="option.id" :key="option.id">{{option.name}}</Option>
                </Select>
                <Button type="primary" style="margin-left: 5px;" @click="onAddClientInfoBtn">添加客户信息</Button>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem prop="vehicleOwnerInfoId" label="车辆所有人信息">
                <Select
                  placeholder="请选择车辆所有人名称"
                  v-model="installOrder.tempVehicleInfo.vehicleOwnerInfoId"
                  filterable
                  remote
                  :remote-method="searchVehicleOwnerInfo"
                  :loading="searchVehicleOwnerInfoLoading"
                  class="field" style="width: 60%;"
                  clearable>
                  <Option v-for="(option, index) in searchVehicleOwnerInfoList" :value="option.id" :key="option.id">{{option.name}}</Option>
                </Select>
                <Button type="primary" style="margin-left: 5px;" @click="onAddVehicleOwnerInfoBtn">添加所有人</Button>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem prop="vehicleInfoGroupId" label="预绑定车辆分组">
                <Select
                  placeholder="请选择车辆分组名称"
                  v-model="installOrder.vehicleInfoGroupId"
                  filterable
                  remote
                  :remote-method="searchVehicleInfoGroup"
                  :loading="searchVehicleInfoGroupLoading"
                  class="field" style="width: 60%;"
                  clearable placement="top">
                  <Option v-for="(option, index) in searchVehicleInfoGroupList" :value="option.id" :key="option.id">{{option.name}}</Option>
                </Select>
                <Button type="primary" style="margin-left: 5px;" @click="onAddClientInfoGroupBtn">添加车辆分组</Button>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem prop="salesChannelId" label="销售渠道">
                <Select placeholder="请选择销售渠道"
                        v-model="installOrder.salesChannelId"
                        filterable
                        remote
                        :remote-method="searchSalesChannel"
                        :loading="searchSalesChannelLoading"
                        class="field" style="width: 60%;"
                        clearable placement="top">
                  <Option v-for="(option, index) in searchSalesChannelList" :value="option.id" :key="option.id">{{option.name}}</Option>
                </Select>
                <Button type="primary" style="margin-left: 5px;" @click="onAddsearchSalesBtn">添加销售渠道</Button>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="4">
              <FormItem prop="attention" label="重点关注">
                <Checkbox v-model="installOrder.tempVehicleInfo.attention"></Checkbox>
              </FormItem>
            </Col>
            <Col span="4">
              <FormItem prop="reInstall" label="重新安装">
                <Checkbox v-model="installOrder.reInstall"></Checkbox>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="installerId" label="安装维修员">
                <Select class="field" v-model="installOrder.installerId">
                  <Option v-for="item in installers" :value="item.value" :key="item.label">{{item.label}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem prop="orderRemark" label="订单备注">
                <Input class="field" style="width: 80%;" v-model="installOrder.remark" type="textarea">
                </Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </TabPane>
      <TabPane label="车辆基本信息">
        <Form ref="loginForm" :model="installOrder.tempVehicleInfo" :rules="rules">
          <Row>
            <Col span="8">
              <FormItem prop="registrationNum">
                <label>自定义名称</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.customName" placeholder="请输入自定义名称">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleTypeName">
                <label>车辆类型</label>
                <Select
                  placeholder="请输入车辆类型名称"
                  v-model="installOrder.tempVehicleInfo.vehicleType.name"
                  filterable
                  remote
                  :remote-method="searchVehicleType"
                  :loading="searchVehicleTypeLoading"
                  class="field"
                  clearable>
                  <Option v-for="(option, index) in searchVehicleTypeList" :value="option.name" :key="option.name">{{option.name}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleBrandName">
                <label>车辆品牌</label>
                <Select
                  placeholder="请输入车辆品牌名称"
                  v-model="installOrder.tempVehicleInfo.vehicleBrand.name"
                  filterable
                  remote
                  :remote-method="searchVehicleBrand"
                  :loading="searchVehicleBrandLoading"
                  class="field"
                  clearable>
                  <Option v-for="(option, index) in searchVehicleBrandList" :value="option.name" :key="option.name">{{option.name}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="bodyColor">
                <label>车身颜色</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.bodyColor" placeholder="请输入车身颜色">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="engineNum">
                <label>发动机号</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.engineNum" placeholder="请输入发动机号">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleLicenseNum">
                <label>行驶证号</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.vehicleLicenseNum" placeholder="请输入行驶证号">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="unladenMass">
                <label>整备质量(kg)</label>
                <InputNumber class="field" :min="0" v-model="installOrder.tempVehicleInfo.unladenMass"
                             placeholder="请输入整备质量"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="engineNum">
                <label>核准载重(kg)</label>
                <InputNumber class="field" :min="0" v-model="installOrder.tempVehicleInfo.approvedLoad"
                             placeholder="请输入核准载重"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleUse">
                <label>使用性质</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.vehicleUse" placeholder="请输入使用性质">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem prop="remark">
                <label>备注</label>
                <Input class="field" style="width: 80%;" v-model="installOrder.tempVehicleInfo.remark" type="textarea"
                       placeholder="请输入备注">
                </Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </TabPane>
      <TabPane label="车辆基本信息1">
        <Form ref="loginForm" :model="installOrder.tempVehicleInfo" :rules="rules">
          <Row>
            <Col span="8">
              <FormItem prop="servicePassword">
                <label>服务密码</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.servicePassword" placeholder="请输入服务密码">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleLicenseDistributeDatetime">
                <label>行驶证发证日期</label>
                <DatePicker type="date" v-model="installOrder.tempVehicleInfo.vehicleLicenseDistributeDatetime"
                            placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleLicenseReigsterDatetime">
                <label>行驶证注册日期</label>
                <DatePicker type="date" v-model="installOrder.tempVehicleInfo.vehicleLicenseReigsterDatetime"
                            placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="certificateNum">
                <label>合格证编号</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.certificateNum" placeholder="请输入合格证编号">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="certificateDistributeDatetime">
                <label>合格证发证日期</label>
                <DatePicker class="field" style="width: 60%;" type="date"
                            v-model="installOrder.tempVehicleInfo.certificateDistributeDatetime"
                            placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleModelName">
                <label>车辆型号</label>
                <Select
                  placeholder="请输入车辆型号名称"
                  v-model="installOrder.tempVehicleInfo.vehicleModel.name"
                  filterable
                  remote
                  :remote-method="searchVehicleModel"
                  :loading="searchVehicleModelLoading"
                  class="field"
                  clearable>
                  <Option v-for="(option, index) in searchVehicleModelList" :value="option.name" :key="option.name">{{option.name}}</Option>
                </Select>
              </FormItem   >
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="chassisModel">
                <label>底盘型号</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.chassisModel" placeholder="请输入底盘型号">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="chassisId">
                <label>底盘ID</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.chassisId" placeholder="请输入底盘ID">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="chassisCertificateNum">
                <label>底盘合格证编号</label>
                <Input class="field" style="width: 60%;" v-model="installOrder.tempVehicleInfo.chassisCertificateNum"
                       placeholder="请输入底盘合格证编号">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="engineModel">
                <label>发动机型号</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.engineModel" placeholder="请输入发动机型号">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="energyType">
                <label>发动机类型</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.energyType" placeholder="请输入发动机类型">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="displacement">
                <label>能耗</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.displacement" placeholder="请输入能耗">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="engineModel">
                <label>发动机型号</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.engineModel" placeholder="请输入发动机型号">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="energyType">
                <label>发动机类型</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.energyType" placeholder="请输入发动机类型">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="displacement">
                <label>排量(ml)</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.displacement" placeholder="请输入排量">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="power">
                <label>功率(kW)</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.power" placeholder="请输入功率">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="energyUsage">
                <label>能耗</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.energyUsage" placeholder="请输入能耗">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="emissionStandard">
                <label>排放标准</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.emissionStandard" placeholder="请输入排放标准">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="manufacturer">
                <label>制造商名称</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.manufacturer" placeholder="请输入制造商名称">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="springPieceCount">
                <label>钢板弹簧片数</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.springPieceCount" placeholder="请输入钢板弹簧片数">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="turnType">
                <label>转向形式</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.turnType" placeholder="请输入转向形式">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="outlineSizeLong">
                <label>外廓尺寸长(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="installOrder.tempVehicleInfo.outlineSizeLong"
                             placeholder="请输入外廓尺寸长"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="outlineSizeWidth">
                <label>外廓尺寸宽(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="installOrder.tempVehicleInfo.outlineSizeWidth"
                             placeholder="请输入外廓尺寸宽"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="outlineSizeHeight">
                <label>外廓尺寸高(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="installOrder.tempVehicleInfo.outlineSizeHeight"
                             placeholder="请输入外廓尺寸高"></InputNumber>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="boxSizeLong">
                <label>货厢内部尺寸长(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="installOrder.tempVehicleInfo.boxSizeLong"
                             placeholder="请输入货厢内部尺寸长"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="boxSizeWidth">
                <label>货厢内部尺寸宽(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="installOrder.tempVehicleInfo.boxSizeWidth"
                             placeholder="请输入货厢内部尺寸宽"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="boxSizeHeight">
                <label>货厢内部尺寸高(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="installOrder.tempVehicleInfo.boxSizeHeight"
                             placeholder="请输入货厢内部尺寸高"></InputNumber>
              </FormItem>
            </Col>
          </Row>

        </Form>
      </TabPane>
      <TabPane label="车辆基本信息2">
        <Form ref="loginForm" :model="installOrder" :rules="rules">
          <Row>
            <Col span="8">
              <FormItem prop="tyreCount">
                <label>轮胎数量</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.tyreCount" placeholder="请输入轮胎数量">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="tyreSpec">
                <label>轮胎规格</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.tyreSpec" placeholder="请输入轮胎规格">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="wheelSpanFront">
                <label>前轮距</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.wheelSpanFront" placeholder="请输入前轮距">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="wheelSpanBack">
                <label>后轮距</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.wheelSpanBack" placeholder="请输入后轮距">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="wheelBase">
                <label>轴距</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.wheelBase" placeholder="请输入轴距">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="axisLoad">
                <label>轴荷(kg)</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.axisLoad" placeholder="请输入轴荷">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="axisCount">
                <label>轴数</label>
                <Input class="field" v-model="installOrder.tempVehicleInfo.axisCount" placeholder="请输入轴数">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="totalMass">
                <label>总质量(kg)</label>
                <InputNumber :min="0" class="field" v-model="installOrder.tempVehicleInfo.totalMass" placeholder="请输入总质量">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="approvedLoadCoefficient">
                <label>载质量利用系数</label>
                <Input class="field" style="width: 50%;" v-model="installOrder.tempVehicleInfo.approvedLoadCoefficient"
                       placeholder="请输入载质量利用系数">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="towMax">
                <label>准牵引总质量(kg)</label>
                <InputNumber :min="0" style="width: 30%;" class="field" v-model="installOrder.tempVehicleInfo.towMax"
                             placeholder="请输入准牵引总质量">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="saddleMax">
                <label>半挂车鞍座最大允许总质量(kg)</label>
                <InputNumber :min="0" class="field" style="width: 30%;" v-model="installOrder.tempVehicleInfo.saddleMax"
                             placeholder="请输入半挂车鞍座最大允许总质量">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="cabPeopleCount">
                <label>驾驶室准乘人数(人)</label>
                <InputNumber :min="0" class="field" style="width: 50%;" v-model="installOrder.tempVehicleInfo.cabPeopleCount"
                             placeholder="请输入驾驶室准乘人数">
                </InputNumber>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="mannedCount">
                <label>额定载客(人)</label>
                <InputNumber :min="0" class="field" v-model="installOrder.tempVehicleInfo.mannedCount" placeholder="请输入额定载客">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="speedMax">
                <label>最高设计车速(km/h)</label>
                <InputNumber :min="0" style="width: 40%;" class="field" v-model="installOrder.tempVehicleInfo.speedMax"
                             placeholder="请输入最高设计车速">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="productionDatetime">
                <label>车辆制造日期</label>
                <DatePicker type="date" v-model="installOrder.tempVehicleInfo.productionDatetime"
                            placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem prop="certificateRemark">
                <label>合格证备注</label>
                <Input class="field" style="width: 80%;" v-model="installOrder.tempVehicleInfo.certificateRemark" type="textarea"
                       placeholder="请输入合格证备注">
                </Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </TabPane>
    </Tabs>
    <add-client-info-modal v-model="addClientInfoModal" :businessUserId="installOrder.businessUserId" @on-success="onSuccess"></add-client-info-modal>
    <add-vehicle-info-group-noparent-modal v-model="addVehicleInfoGroupNoparentModal" :parentGroupId="addVehicleInfoGroupParentId"></add-vehicle-info-group-noparent-modal>
    <add-vehicle-owner-info-modal v-model="addVehicleOwnerInfoModal" @on-success="onSuccess"></add-vehicle-owner-info-modal>
    <add-positioning-device-fittings-modal  v-model="AddPositioningDeviceFittingsModal" :initValue="AddPositioningDeviceFittingsModalId"
                                            :terminalNumValue="AddPositioningDeviceFittingsModalterminalNum" @on-positioningdevicefittings="onPositioningdevicefittings"></add-positioning-device-fittings-modal>
    <add-saleschannel-info-modal v-model="addSaleschannelInfoModal" @on-success="onSuccess"></add-saleschannel-info-modal>
  </Modal>
</template>
<script>

import AddClientInfoModal from '@/view/crm/components/add-client-info-modal'
import AddVehicleInfoGroupNoparentModal from '@/view/crm/components/add-vehicle-info-group-noparent-modal'
import AddVehicleOwnerInfoModal from '@/view/crm/components/add-vehicle-owner-info-modal'
import AddPositioningDeviceFittingsModal from '@/view/im/components/add-positioning-device-fittings-modal'
import AddSaleschannelInfoModal from '@/view/crm/components/add-saleschannel-info-modal'

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'addinstallordermodal',
  components: {
    AddClientInfoModal,
    AddVehicleInfoGroupNoparentModal,
    AddVehicleOwnerInfoModal,
    AddPositioningDeviceFittingsModal,
    AddSaleschannelInfoModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    registrationNumRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '车牌号/车架号二选一填写', trigger: 'blur' }
        ]
      }
    },
    colorRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '车牌颜色不能为空', trigger: 'blur' }
        ]
      }
    },
    vinRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '车牌号/车架号二选一填写', trigger: 'blur' }
        ]
      }
    },
    totalAmountRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '填写金额', trigger: 'blur' }
        ]
      }
    },
    serviceDateNumRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '服务时长', trigger: 'blur' }
        ]
      }
    },
    businessTypeRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '选择业务类型', trigger: 'blur' }
        ]
      }
    },
    vehicleTypeNameRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '填写车辆类型，如：重型厢式货车', trigger: 'blur' }
        ]
      }
    },
    businessUserIdRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '请选择业务员', trigger: 'blur' }
        ]
      }
    },
    qghyptOptionRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '全国货运平台上传类型', trigger: 'blur' }
        ]
      }
    },
    billTypeRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '请选择发票类型', trigger: 'blur' }
        ]
      }
    },
    isfreeRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '请选择订单类型', trigger: 'blur' }
        ]
      }
    },
    clientInfoIdRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '客户信息', trigger: 'blur' }
        ]
      }
    },
    vehicleOwnerInfoIdRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '车辆所有人信息', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {
      // 添加销售渠道
      addSaleschannelInfoModal: false,

      // 添加车辆所有人
      addVehicleOwnerInfoModal: false,

      // 添加客户信息
      addClientInfoModal: false,

      // 添加车辆分组
      addVehicleInfoGroupNoparentModal: false,
      addVehicleInfoGroupParentId: null,

      // 添加定位设备配件
      AddPositioningDeviceFittingsModal: false,
      AddPositioningDeviceFittingsModalId: null,

      searchSalesChannelValue: null,
      searchSalesChannelLoading: false,
      searchSalesChannelList: [],

      searchVehicleInfoGroupList: [],
      searchVehicleInfoGroupLoading: false,

      searchVehicleModelLoading: false,
      searchVehicleModelList: [],
      searchClientInfoLoading: false,
      searchClientInfoList: [],
      searchVehicleOwnerInfoLoading: false,
      searchVehicleOwnerInfoList: [],
      searchVehicleTypeLoading: false,
      searchVehicleTypeList: [],
      searchVehicleBrandLoading: false,
      searchVehicleBrandList: [],

      billType: [
        { label: '增值税发票', value: 1 },
        { label: '增值税专用发票', value: 2 },
        { label: '增值税普通发票', value: 3 },
        { label: '增值税电子专用发票', value: 4 },
        { label: '增值税电子普通发票', value: 5 }
      ],

      qghyptOptions: [
        { label: '不需上传', value: 0 },
        { label: '新车上传', value: 1 },
        { label: '旧车转网', value: 2 }
      ],

      // 订单模式
      orderTypeOptions: [
        { label: '自费安装模式', value: 1 },
        { label: '普通免费模式', value: 2 },
        { label: '太好保模式', value: 3 }
      ],

      // 交强险选择
      searchMLIFTAinsuranceChannelList: [],
      searchMLIFTAinsuranceChannelLoading: false,

      // 商业险选择
      searchTIinsuranceChannelList: [],
      searchTIinsuranceChannelLoading: false,

      installOrderBusinessType: [
        { label: '新装', value: 1 },
        { label: '接入', value: 2 }
      ],

      registrationColorOptions: [
        { label: '蓝色', value: 1 },
        { label: '黄色', value: 2 },
        { label: '黑色', value: 3 },
        { label: '白色', value: 4 },
        { label: '渐变绿色', value: 5 },
        { label: '黄绿色', value: 6 },
      ],

      businessUsers: [],
      installers: [],
      isok: null,
      serviceDateNum: null,
      installOrder: {
        totalAmount: 0,
        serviceDatetime: null,
        businessUserId: null,
        businessType: 1,
        multiDevices: false,
        qghyptOption: 0,
        clientInfoId: null,
        remark: null,
        billType: 1,
        vehicleInfoGroupId: null,
        vehicleInfoGroupId: null,
        positioningDeviceId: null,
        vehicleInfoId: null,
        isfree: 1,
        reInstall: false,
        tempVehicleInfo: {
          customName: null,
          registrationNum: null,
          registrationColor: null,
          vin: null,
          bodyColor: null,
          vehicleType: {
            name: null
          },
          vehicleBrand: {
            name: null
          },
          engineNum: null,
          vehicleLicenseNum: null,
          unladenMass: null,
          approvedLoad: null,
          vehicleOwnerInfoId: null,
          servicePassword: null,
          vehicleLicenseDistributeDatetime: null,
          vehicleLicenseReigsterDatetime: null,
          remark: null,
          certificateNum: null,
          certificateDistributeDatetime: null,
          vehicleModel: {
            name: null
          },
          chassisModel: null,
          chassisId: null,
          chassisCertificateNum: null,
          engineModel: null,
          energyType: null,
          displacement: null,
          power: null,
          energyUsage: null,
          emissionStandard: null,
          manufacturer: null,
          outlineSizeLong: null,
          outlineSizeWidth: null,
          outlineSizeHeight: null,
          boxSizeLong: null,
          boxSizeWidth: null,
          boxSizeHeight: null,
          springPieceCount: null,
          tyreCount: null,
          tyreSpec: null,
          wheelSpanFront: null,
          wheelSpanBack: null,
          wheelBase: null,
          axisLoad: null,
          axisCount: null,
          turnType: null,
          totalMass: null,
          approvedLoadCoefficient: null,
          towMax: null,
          saddleMax: null,
          cabPeopleCount: null,
          mannedCount: null,
          speedMax: null,
          productionDatetime: null,
          certificateRemark: null,
          vehicleLicensePictureId: null,
          certificatePictureId: null,
          vehicleSrcLicensePicture1Id: null,
          vehicleSrcLicensePicture2Id: null,
          vehicleBodyPictureId: null,
          vehicleUse: null,
          attention: false,
          mliftainsuranceChannelId: null,
          mliftainsurancechannelDatetime: null,
          tiinsuranceChannelId: null,
          tiinsurancechannelDatetime: null,
          insured: null
        },
        salesChannelId: null,
        urgent: '否',
        receptDatetime: '否',
        stepId: null,
        step: {
          orderId: null,
          state: null,
          lastState: null,
          userId: null,
          user: null,
          result: null
        },
        bookingDatetime: new Date(new Date().setDate(new Date().getDate() + 1)),
        bookingPlace: null,
        actualDatetime: null,
        actualPlace: null
      }
    }
  },
  methods: {
    ...mapActions([
      'InstallOrderServ_AddObj',
      'UserServ_GetAllUsers'
    ]),
    // onDeviceAndFittings () {
    //   this.AddPositioningDeviceFittingsModal = true
    //   this.AddPositioningDeviceFittingsModalId = this._initValue
    // },
    // onCheckClick(){
    //   console.log('查询运营资格')
    //   console.log(this.installOrder.tempVehicleInfo.registrationNum)
    //   store.dispatch('VehicleInfoServ_InquireOperation',{
    //     params:{
    //       registrationNum : this.installOrder.tempVehicleInfo.registrationNum
    //     }
    //   }).then(res=>{
    //     console.log(store.getters.get_VehicleInfo_InquireOperationResult)
    //     if (store.getters.get_VehicleInfo_InquireOperationResult) {
    //     this.isok=true
    //     }else {
    //       this.isok=false
    //     }
    //   }).catch(err=>{
    //   this.isok=false
    //     console.log(err)
    //     this.$Message.error(err)
    //   })
    // },
    changeServiceDateNum (e) {
      // console.log(e)
      // console.log(new Date().getMonth())
      // console.log(new Date(new Date().setMonth(e)).Format('yyyy-MM-dd'))
      this.installOrder.serviceDatetime = new Date(new Date().setMonth(new Date().getMonth() + e)).Format('yyyy-MM-dd')
      console.log(this.installOrder.serviceDatetime)
    },
    changeServiceDatetime (e) {
      // console.log(e)
      // console.log(new Date(e))
      this.serviceDateNum = new Date(e).getMonth() - new Date().getMonth()
    },
    onAddVehicleOwnerInfoBtn () {
      this.addVehicleOwnerInfoModal = true
    },
    onAddClientInfoBtn () {
      if (!this.installOrder.businessUserId) {
        this.$Message.error('请先选择跟进业务员')
        return
      }
      this.addClientInfoModal = true
    },
    onAddClientInfoGroupBtn () {
      this.addVehicleInfoGroupNoparentModal = true
    },
    onAddsearchSalesBtn () {
      this.addSaleschannelInfoModal = true
    },
    onSuccess () {

    },
    options (date) {
      return date && date.valueOf() < Date.now() - 86400000
    },
    onChange (date) {

    },
    searchVehicleType (input) {
      this.searchVehicleTypeLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleTypeList = []
        this.searchVehicleTypeLoading = false
      } else {
        store.dispatch('VehicleTypeServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleTypeList = store.getters.get_VehicleType_SearchByNameResult ? store.getters.get_VehicleType_SearchByNameResult : []
          this.searchVehicleTypeLoading = false
        }).catch(err => {
          this.searchVehicleTypeLoading = false
        })
      }
    },
    searchVehicleBrand (input) {
      this.searchVehicleBrandLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleBrandList = []
        this.searchVehicleBrandLoading = false
      } else {
        store.dispatch('VehicleBrandServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleBrandList = store.getters.get_VehicleBrand_SearchByNameResult ? store.getters.get_VehicleBrand_SearchByNameResult : []
          this.searchVehicleBrandLoading = false
        }).catch(err => {
          this.searchVehicleBrandLoading = false
        })
      }
    },
    searchVehicleOwnerInfo (input) {
      this.searchVehicleOwnerInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleOwnerInfoList = []
        this.searchVehicleOwnerInfoLoading = false
      } else {
        store.dispatch('VehicleOwnerInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleOwnerInfoList = store.getters.get_VehicleOwnerInfo_SearchByNameResult ? store.getters.get_VehicleOwnerInfo_SearchByNameResult : []
          this.searchVehicleOwnerInfoLoading = false
        }).catch(err => {
          this.searchVehicleOwnerInfoLoading = false
        })
      }
    },
    searchVehicleInfoGroup (input) {
      this.searchVehicleInfoGroupLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleInfoGroupList = []
        this.searchVehicleInfoGroupLoading = false
      } else {
        store.dispatch('VehicleInfoGroupServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleInfoGroupList = store.getters.get_VehicleInfoGroup_SearchByNameResult ? store.getters.get_VehicleInfoGroup_SearchByNameResult : []
          this.searchVehicleInfoGroupLoading = false
        }).catch(err => {
          this.searchVehicleInfoGroupLoading = false
        })
      }
    },
    searchSalesChannel (input) {
      this.searchSalesChannelLoading = true
      if (!input || input.length <= 0) {
        this.searchSalesChannelList = []
        this.searchSalesChannelLoading = false
      } else {
        store.dispatch('SalesChannelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchSalesChannelList = store.getters.get_SalesChannel_SearchByNameResult ? store.getters.get_SalesChannel_SearchByNameResult : []
          this.searchSalesChannelLoading = false
        }).catch(err => {
          this.searchSalesChannelLoading = false
        })
      }
    },
    searchClientInfo (input) {
      this.searchClientInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchClientInfoList = []
        this.searchClientInfoLoading = false
      } else {
        store.dispatch('ClientInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchClientInfoList = store.getters.get_ClientInfo_SearchByNameResult ? store.getters.get_ClientInfo_SearchByNameResult : []
          this.searchClientInfoLoading = false
        }).catch(err => {
          this.searchClientInfoLoading = false
        })
      }
    },
    searchVehicleModel (input) {
      this.searchVehicleModelLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleModelList = []
        this.searchVehicleModelLoading = false
      } else {
        store.dispatch('VehicleModelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleModelList = store.getters.get_VehicleModel_SearchByNameResult ? store.getters.get_VehicleModel_SearchByNameResult : []
          this.searchVehicleModelLoading = false
        }).catch(err => {
          this.searchVehicleModelLoading = false
        })
      }
    },
    searchMLIFTAinsuranceChannel (input) {
      this.searchMLIFTAinsuranceChannelLoading = true
      if (!input || input.length <= 0) {
        this.searchMLIFTAinsuranceChannelList = []
        this.searchMLIFTAinsuranceChannelLoading = false
      } else {
        store.dispatch('InsuranceChannelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchMLIFTAinsuranceChannelList = store.getters.get_InsuranceChannel_SearchByNameResult ? store.getters.get_InsuranceChannel_SearchByNameResult : []
          this.searchMLIFTAinsuranceChannelLoading = false
        }).catch(err => {
          this.searchMLIFTAinsuranceChannelLoading = false
        })
      }
    },
    searchTIinsuranceChannel (input) {
      this.searchTIinsuranceChannelLoading = true
      if (!input || input.length <= 0) {
        this.searchTIinsuranceChannelList = []
        this.searchTIinsuranceChannelLoading = false
      } else {
        store.dispatch('InsuranceChannelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchTIinsuranceChannelList = store.getters.get_InsuranceChannel_SearchByNameResult ? store.getters.get_InsuranceChannel_SearchByNameResult : []
          this.searchTIinsuranceChannelLoading = false
        }).catch(err => {
          this.searchTIinsuranceChannelLoading = false
        })
      }
    },
    onOk () {
      if (this.installOrder.tempVehicleInfo.vehicleType.name == null) {
        this.$Message.error('请输入车辆类型')
        return
      }
      if (this.installOrder.receptDatetime == '是') {
        this.installOrder.receptDatetime = new Date()
      } else {
        this.installOrder.receptDatetime = null
      }
      if (this.installOrder.urgent == '是') {
        this.installOrder.urgent = true
      } else {
        this.installOrder.urgent = false
      }
      this.$Modal.confirm({
        title: '添加安装订单信息',
        content: '<p>添加安装订单信息</p>',
        onOk: () => {
          store.dispatch('InstallOrderServ_AddObj', { params: this.installOrder }).then(() => {
            this.$Message.success('添加安装订单信息')
            this.AddPositioningDeviceFittingsModal = true
            this.AddPositioningDeviceFittingsModalId = store.getters.get_InstallOrder_AddObjResult.id
            this.cleanData()
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.isok = null
        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [7] }
        }).then(() => {
          this.businessUsers = store.getters.get_User_GetAllUsersResult
        }).catch(err => {
          this.$Message.error(err)
        })

        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [8, 14] }
        }).then(() => {
          // this.installers = store.getters.get_User_GetAllUsersResult
          let installers = store.getters.get_User_GetAllUsersResult
          installers.forEach(item => {
            if (item.state === 1){
              // console.log(item.id)
              // console.log(item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name)
              this.installers.push({ label: item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name, value: item.id })
            }
          })
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    },
    cleanData () {
      this.installOrder.businessUserId = null
      this.installOrder.tempVehicleInfo.customName = null
      this.installOrder.tempVehicleInfo.registrationNum = null
      this.installOrder.tempVehicleInfo.registrationColor = null
      this.installOrder.tempVehicleInfo.vin = null
      this.installOrder.tempVehicleInfo.bodyColor = null
      this.installOrder.tempVehicleInfo.vehicleType.name = null
      this.installOrder.tempVehicleInfo.vehicleBrand.name = null
      this.installOrder.tempVehicleInfo.engineNum = null
      this.installOrder.tempVehicleInfo.vehicleLicenseNum = null
      this.installOrder.tempVehicleInfo.unladenMass = null
      this.installOrder.tempVehicleInfo.approvedLoad = null
      this.installOrder.tempVehicleInfo.vehicleOwnerInfoId = null
      this.installOrder.tempVehicleInfo.clientInfoId = null
      this.installOrder.tempVehicleInfo.servicePassword = null
      this.installOrder.tempVehicleInfo.vehicleLicenseDistributeDatetime = null
      this.installOrder.tempVehicleInfo.vehicleLicenseReigsterDatetime = null
      this.installOrder.tempVehicleInfo.remark = null
      this.installOrder.tempVehicleInfo.certificateNum = null
      this.installOrder.tempVehicleInfo.certificateDistributeDatetime = null
      this.installOrder.tempVehicleInfo.vehicleModel.name = null
      this.installOrder.tempVehicleInfo.chassisModel = null
      this.installOrder.tempVehicleInfo.chassisId = null
      this.installOrder.tempVehicleInfo.chassisCertificateNum = null
      this.installOrder.tempVehicleInfo.engineModel = null
      this.installOrder.tempVehicleInfo.energyType = null
      this.installOrder.tempVehicleInfo.displacement = null
      this.installOrder.tempVehicleInfo.power = null
      this.installOrder.tempVehicleInfo.energyUsage = null
      this.installOrder.tempVehicleInfo.emissionStandard = null
      this.installOrder.tempVehicleInfo.manufacturer = null
      this.installOrder.tempVehicleInfo.outlineSizeLong = null
      this.installOrder.tempVehicleInfo.outlineSizeWidth = null
      this.installOrder.tempVehicleInfo.outlineSizeHeight = null
      this.installOrder.tempVehicleInfo.boxSizeLong = null
      this.installOrder.tempVehicleInfo.boxSizeWidth = null
      this.installOrder.tempVehicleInfo.boxSizeHeight = null
      this.installOrder.tempVehicleInfo.springPieceCount = null
      this.installOrder.tempVehicleInfo.tyreCount = null
      this.installOrder.tempVehicleInfo.tyreSpec = null
      this.installOrder.tempVehicleInfo.wheelSpanFront = null
      this.installOrder.tempVehicleInfo.wheelSpanBack = null
      this.installOrder.tempVehicleInfo.wheelBase = null
      this.installOrder.tempVehicleInfo.axisLoad = null
      this.installOrder.tempVehicleInfo.axisCount = null
      this.installOrder.tempVehicleInfo.turnType = null
      this.installOrder.tempVehicleInfo.totalMass = null
      this.installOrder.tempVehicleInfo.approvedLoadCoefficient = null
      this.installOrder.tempVehicleInfo.towMax = null
      this.installOrder.tempVehicleInfo.saddleMax = null
      this.installOrder.tempVehicleInfo.cabPeopleCount = null
      this.installOrder.tempVehicleInfo.mannedCount = null
      this.installOrder.tempVehicleInfo.speedMax = null
      this.installOrder.tempVehicleInfo.productionDatetime = null
      this.installOrder.tempVehicleInfo.certificateRemark = null
      this.installOrder.tempVehicleInfo.vehicleLicensePictureId = null
      this.installOrder.tempVehicleInfo.certificatePictureId = null
      this.installOrder.tempVehicleInfo.vehicleSrcLicensePicture1Id = null
      this.installOrder.tempVehicleInfo.vehicleSrcLicensePicture2Id = null
      this.installOrder.tempVehicleInfo.vehicleBodyPictureId = null
      this.installOrder.tempVehicleInfo.test = false
      this.installOrder.tempVehicleInfo.vehicleUse = null
      this.installOrder.salesChannelId = null
      this.searchMLIFTAinsuranceChannelList = []
      this.searchTIinsuranceChannelList = []
      this.installOrder.tempVehicleInfo.mliftainsuranceChannelId = null
      this.installOrder.tempVehicleInfo.mliftainsurancechannelDatetime = null
      this.installOrder.tempVehicleInfo.tiinsuranceChannelId = null
      this.installOrder.tempVehicleInfo.tiinsurancechannelDatetime = null
      this.installOrder.tempVehicleInfo.insured = null
      this.installOrder.urgent = null
      this.installOrder.receptDatetime = null
      this.installOrder.stepId = null
      this.installOrder.step = null
      this.installOrder.bookingDatetime = null
      this.installOrder.bookingPlace = null
      this.installOrder.actualDatetime = null
      this.installOrder.actualPlace = null
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        registrationNum: this.registrationNumRules,
        color: this.colorRules,
        vin: this.vinRules,
        totalAmount: this.totalAmountRules,
        serviceDateNum: this.serviceDateNumRules,
        businessType: this.businessTypeRules,
        vehicleTypeName: this.vehicleTypeNameRules,
        businessUserId: this.businessUserIdRules,
        qghyptOption: this.qghyptOptionRules,
        billType: this.billTypeRules,
        isfree: this.isfreeRules,
        clientInfoId: this.clientInfoIdRules,
        vehicleOwnerInfoId: this.vehicleOwnerInfoIdRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
    })
  }
}
</script>

<style scoped>

  .field {
    margin-left: 5px;
    width: 70%;
  }
</style>
